<template>
    <form action="" class="form main-content__form" v-if="events.length">
        <div class="main-content__row">
            <p class="little-sm">Вы всего в паре шагов от регистрации на регату! <br>Выберите количество участников и
                удобную дату поездки.</p>
            <div class="number-wrap">
                <div class="number-wrap">
                    <div class="jq-number js-styler form__number">
                        <div class="jq-number__field">
                            <input class="js-styler form__number" type="number" v-model="membersCount" min="1" max="99">
                            <span class="members-name">{{ membersName }}</span>
                        </div>
                        <div class="jq-number__spin minus" :class="isMembersMinusDisabled ? 'disabled' : ''"
                             @click="decMembersCount"></div>
                        <div class="jq-number__spin plus" :class="isMembersPlusDisabled ? 'disabled' : ''"
                             @click="incMembersCount"></div>

                        <span class="discounts-mess" :class="isMembersCountDiscount ? 'discounts-mess_active' : ''" v-if="currentEvent.discount_members_count && currentEvent.discount_members_count.count">
                            От {{ currentEvent.discount_members_count.count }}
                            {{ membersDiscountName }} скидка {{ currentEvent.discount_members_count.amount }}%
                        </span>

                    </div>
                </div>
            </div>
        </div>
        <div class="main-content__row">
            <div class="form__radio-date-wrap" v-for="event in events" v-bind:key="event.id">
                <input v-bind:id="event.id" class="form__radio-date" type="radio" name="date"
                       :checked="event.id == currentEventId">
                <label v-bind:for="event.id" class="form__radio-date-label" @click="setEvent(event.id)">
                    <div class="form__radio-date-left">

													<span class="form__radio-date-title">
														{{ event.startDate }} — {{ event.endDate }}
													</span>
                        <div class="form__radio-date-title form__radio-date-members">
                            {{ event.placeCount }}
                        </div>
                        <span class="form__radio-date-text">
														{{ event.name }}
													</span>
                    </div>
                </label>
            </div>

            <mobile-price />
            <div class="main-board__footer main-content__footer sm-only" v-if="currentEventId">
                <div class="button-wrap">
                    <button type="submit" class="form__button button" value="Далее" @click="submit">
                        Далее
                    </button>
                    <span class="button_disabled-before">Необходимо заполнить все поля</span>
                </div>
            </div>
            <div class="button-wrap md">
                <button type="submit" class="form__button button" value="Далее" @click="submit"
                    v-if="currentEventId">
                    Далее
                </button>
                <span class="button_disabled-before">Необходимо заполнить все поля</span>
            </div>
        </div>
    </form>
    <div class="form main-content__form" v-else>
        <div class="main-content__row">
            Все места закрыты
        </div>
    </div>
</template>

<script>
    /* global WecanGtm */
    import {mapGetters, mapState} from 'vuex'
    import { mapMutations } from 'vuex'
    import { mapActions } from 'vuex'
    import MobilePrice from "./MobilePrice";

    export default {
        components: {MobilePrice},
        mounted () {
            let self = this

            this.getEvents(this.$route.params.slug);

            if (this.isOverdueTime) {
                let message = 'Извините, время оплаты истекло';

                this.$alert(message,
                    '', 'warning');
            }

            this.setIsOverdueTime(false);

            setTimeout(function() {
                self.sendGtmInfo()
            }, 2000)
        },
        beforeMount() {

            if (this.currentEventId) {
                this.getEvent();
            }
        },
        methods:{
            submit: function () {
                this.$router.push({
                    name: 'contacts',
                    params: {
                        slug: this.$router.currentRoute.params.slug,
                        eventId: this.currentEventId,
                    }
                });

                if (typeof WecanGtm !== 'undefined') {
                    WecanGtm.addToCart(
                        this.currentEvent.name,
                        this.currentEvent.direction_id,
                        this.currentEvent.price,
                        process.env.VUE_APP_GTM_CATEGORY,
                        'N/A',
                        this.membersCount,
                        this.currentEvent.currency
                    )
                }
            },
            sendGtmInfo: function () {
                if (this.currentEventId && typeof WecanGtm !== 'undefined') {
                    WecanGtm.productDetail(
                        this.currentEvent.name,
                        this.currentEvent.direction_id,
                        this.currentEvent.price,
                        process.env.VUE_APP_GTM_CATEGORY,
                        'N/A',
                        this.currentEvent.currency
                    )
                }
            },
            ...mapMutations([
                'setEvent',
                'incMembersCount',
                'decMembersCount',
                'setIsOverdueTime'
            ]),
            ...mapActions([
                'getEvents',
                'getEvent',
            ]),
        },
        computed: {
            isMembersMinusDisabled() {
                return this.membersCount <= 1 || !this.currentEventId;
            },
            isMembersPlusDisabled() {
                if (!this.currentEvent && !this.currentEventId) {
                    return true;
                }

                if (!this.isAvailableFreePlaces && this.membersCount === this.currentEvent.free_places) {
                    return true;
                }

                return false;
            },
            membersName() {
                let n = Math.abs(this.membersCount);
                n %= 100;
                if (n >= 5 && n <= 20) {
                    return 'человек';
                }
                n %= 10;
                if (n === 1) {
                    return 'человек';
                }
                if (n >= 2 && n <= 4) {
                    return 'человека';
                }
                return 'человек';
            },
            membersDiscountName() {
                if(this.currentEvent.discount_members_count){
                    let n = Math.abs(this.currentEvent.discount_members_count.count);

                    let n1 = n%10;
                    let n2 =  (n%100+'')[0];

                    if (n1 === 1 && n2 != 1) {
                        return 'человека';
                    }
                    return 'человек';
                }

                return '';
            },
            isMembersCountDiscount() {
                if(this.currentEvent.discount_members_count && this.currentEvent.discount_members_count.count > 0) {
                    return this.membersCount >= this.currentEvent.discount_members_count.count;
                } else {
                    return false;
                }
            },
            ...mapState([
                'events',
                'currentEvent',
                'currentEventId',
                'availableMembersCount',
                'membersCount',
                'isOverdueTime'
            ]),
            ...mapGetters([
                'eventPrice',
                'convertedPrice',
                'currencySymbol',
                'isAvailableFreePlaces'
            ]),
        }
    }
</script>
<style>
    .members-name {
        display: flex;
        align-items: center;
    }

    .jq-number__spin.disabled {
        opacity: 0.2;
    }

    .rouble, .euro {
        display: inline;
        font-family: 'PT Sans', serif;
        margin: 0;
    }

    .main-board__price .euro {
        font-size: 30px;
    }
</style>
